import log from 'loglevel';
import { router } from '../../services'

const getProductListByPLC = async (plcData, credentials) => {
  const type = 'GetPreviousVersionProducts';
  
  try {
    const getSerialNumbersResponse = await router(type, { plc: plcData }, credentials);
    return getSerialNumbersResponse;
  } catch (err) {
    log.error(err);
    return err;
  }
};

export default getProductListByPLC;